import { GET_TENT_TYPES_LOADING, GET_TENT_TYPES_SUCCESS } from '../actionTypes';
import store from '../store';
import { showUnknownError } from './keyboard-shortcuts.actions';
import { client } from '../../services/client';

export const getTentTypesSuccess = payload => {
    return ({
        type: GET_TENT_TYPES_SUCCESS,
        payload
    })
}

export const getTentTypesAsync = payload => dispatch => {
    return client.service('tent-types').find()
		.then((response) => {
            dispatch(getTentTypesSuccess(response));
            return response
		})
        .catch((error) => {
            console.error('error', error);
        })
           
}